export default __webpack_public_path__ + "static/24_18-785594054d014a6012b3211c8f160cec.png";